import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_payment_aggregator_RowClass,
  bl_pgw_payment_aggregator_RowInterface
} from '../../dbschema';

export class PGWPaymentAggregatorContainerModel extends BaseContainerModel {
  bl_pgw_payment_aggregator: bl_pgw_payment_aggregator_RowInterface[] = [];
}
